import type { CSSProperties } from "react";
import type { HeroDesign } from "@/lib/theme-settings";

/**
 * The Phase 4 hero settings (heights, title/description/CTA colors) applied to a slide — shared by every theme's
 * slide markup, so a setting means the same thing in every theme. Each value is applied only when set; an absent
 * override adds no class and no style at all, so an empty design renders the theme's default look.
 */
export function heroSlideStyles(design: HeroDesign) {
  // Appended only when a height override exists, so the class string is unchanged otherwise.
  const heightClass = `${design.desktopHeight !== undefined ? " hero-h-d" : ""}${design.mobileHeight !== undefined ? " hero-h-m" : ""}`;
  const titleStyle = (delay: string): CSSProperties => ({ animationDelay: delay, ...(design.titleColor ? { color: design.titleColor } : {}) });
  const descriptionStyle = (delay: string): CSSProperties => ({ animationDelay: delay, ...(design.descriptionColor ? { color: design.descriptionColor } : {}) });
  const subtitleStyle: CSSProperties | undefined = design.descriptionColor ? { color: design.descriptionColor } : undefined;
  const hasCtaOverride = Boolean(design.buttonBackgroundColor || design.buttonTextColor);
  const ctaClass = hasCtaOverride ? " hero-cta-custom" : "";
  const ctaStyle = (delay: string): CSSProperties => ({
    animationDelay: delay,
    ...(design.buttonBackgroundColor ? { backgroundColor: design.buttonBackgroundColor } : {}),
    ...(design.buttonTextColor ? { color: design.buttonTextColor } : {}),
  });

  return { heightClass, titleStyle, descriptionStyle, subtitleStyle, ctaClass, ctaStyle };
}
